package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.cash_register_configuration.tabs.hardware.component.receipt_printer_config

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.CashRegisterConfig
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.ReceiptPrinterConfig
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api.RestaurantRoom
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Constants.ipAddressRegex
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.*
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*


fun isValidConnectionTarget(input: String) =
    (input.length == 13 && input.firstOrNull()?.let { it.isUpperCase() && it in 'A'..'Z' } == true) ||
            Regex(ipAddressRegex).matches(input)

fun isAllPrintersConfigured(printersList: List<ReceiptPrinterConfig>): Boolean {
    return printersList.all {
        (it.type == Constants.ReceiptPrinters.sunmiIntegrated) ||
        ((it.type == Constants.ReceiptPrinters.sunmiCloud) && (isValidConnectionTarget(it.connectionTarget)))
    }
}

@Composable
fun ReceiptPrinterConfig(
    windowSizeMode: WindowSizeModeEnum,
    cashRegisterConfig: CashRegisterConfig?,
    updateCashRegisterConfig: (List<Pair<String, dynamic>>) -> Unit
) {
    val json = Json { encodeDefaults = true }

    val workList = remember {
        mutableStateListOf<ReceiptPrinterConfig>().apply { addAll(cashRegisterConfig?.receiptPrintersConfig.orEmpty()) }
    }

    LaunchedEffect(cashRegisterConfig) {
        workList.clear()
        workList.addAll(cashRegisterConfig?.receiptPrintersConfig.orEmpty())
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
//        MediumContentTitle(
//            title = Strings.current().receiptPrinterSettings
//        )

        Row(
            modifier = Modifier
                .margin(topBottom = Dimen.smallPadding)
                .fillMaxWidth()
                .border(
                    width = Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb
                )
                .borderRadius(Dimen.lowBorderRadius)
                .padding(Dimen.normalPadding),
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                CustomButton(
                    modifier = Modifier,
                    windowSizeMode = windowSizeMode,
                    width = 20.px,
                    title = " + ",
                    isClickable = workList.size < 3,
                    buttonType = ButtonTypes.CONTAINED,
                    onButtonClick = {
                        if (isAllPrintersConfigured(workList)) {
                            workList.add(ReceiptPrinterConfig(type = "", connectionTarget = "", roomIds = emptyList()))
                        }
                    }
                )

                for (index in workList.indices) {
                    SunmiCloudPrinter(
                        windowSizeMode = windowSizeMode,
                        printerConfig = workList[index],
                        availableRooms = cashRegisterConfig?.restaurantAvailableRooms.orEmpty(),
                        onConfigChange = { updatedConfig ->
                            workList[index] = updatedConfig

                            // We send new config to server only if all printers properly configured
                            if (isAllPrintersConfigured(workList)) {
                                updateCashRegisterConfig(
                                    buildList {
                                        add(ApiUtils.Field.receiptPrintersConfiguration to json.encodeToString(workList.toList()))
                                    }
                                )
                            }
                        },
                        onDelete = {
                            workList.removeAt(index)

                            //For first entry we not apply rooms selection,
                            //so here we clear rooms for first item if it's defined
                            val listToStore = workList.mapIndexed { index, item ->
                                if (index == 0 && item.roomIds.isNotEmpty()) {
                                    item.copy(roomIds = emptyList())
                                } else item
                            }

                            updateCashRegisterConfig(
                                buildList {
                                    add(ApiUtils.Field.receiptPrintersConfiguration to json.encodeToString(listToStore))
                                }
                            )
                        },
                        isAllowRooms = (index > 0) // For first entry we not allow to set rooms
                    )
                }
            }
        }
    }
//    }
}

@Composable
private fun SunmiCloudPrinter(
    windowSizeMode: WindowSizeModeEnum,
    printerConfig: ReceiptPrinterConfig,
    availableRooms: List<RestaurantRoom>,
    onConfigChange: (ReceiptPrinterConfig) -> Unit,
    onDelete: () -> Unit,
    isAllowRooms: Boolean = true
) {
    val printersList = listOf(
        "",
        Constants.ReceiptPrinters.sunmiIntegrated,
        Constants.ReceiptPrinters.sunmiCloud
    )

    val printerType = remember { mutableStateOf(printerConfig.type) }
    val connectionTarget = remember { mutableStateOf(printerConfig.connectionTarget) }
    val roomsList = remember { mutableStateOf(printerConfig.roomIds) }

    LaunchedEffect(printerConfig) {
        printerType.value = printerConfig.type
        connectionTarget.value = printerConfig.connectionTarget
        roomsList.value = printerConfig.roomIds
    }


    //if (windowSizeMode == WindowSizeModeEnum.Desktop) {
        Row(
            modifier = Modifier,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            DropDownItem(
                modifier = Modifier.margin(bottom = Dimen.normalPadding),
                label = Strings.current().printerType,
                options = printersList,
                selectedItem = printersList.find { it == printerType.value },
                displayText = { item -> item as String },
                onOptionClick = {
                    if (it is String) {
                        printerType.value = it
                        connectionTarget.value = "" // When we change printer type, connection target should be cleared

                        onConfigChange(printerConfig.copy(type = printerType.value, connectionTarget = ""))
                    }
                }
            )

            if (printerType.value == Constants.ReceiptPrinters.sunmiCloud) {
                CustomEditText(
                    modifier = Modifier,
                    marginLeft = Dimen.normalPadding,
                    marginBottom = Dimen.normalPadding,
                    label = Strings.current().printerConnectionTarget,
                    width = Dimen.mediumEditTextWidth,
                    inputType = InputType.Text,
                    value = connectionTarget.value,
                    isRequired = true,
                    hint = "",
                    onFocusIn = { },
                    onFocusOut = {
                        if (isValidConnectionTarget(it)) {
                            onConfigChange(printerConfig.copy(connectionTarget = connectionTarget.value))
                        }
                    },
                    onInputChange = { it, validation ->
                        connectionTarget.value = it
                        validation.value = isValidConnectionTarget(it)
                    }
                )

                if (isAllowRooms) {
                    DropDownMultiSelect(
                        modifier = Modifier.margin(bottom = Dimen.normalPadding, left = Dimen.normalPadding),
                        disable = !isValidConnectionTarget(connectionTarget.value),
                        options = availableRooms.map { Pair(it.id, it.caption) },
                        selectedIds = roomsList.value,
                        label = Strings.current().rooms,
                        onSelectionChange = { newSelection ->
                            roomsList.value = newSelection
                            onConfigChange(printerConfig.copy(roomIds = newSelection))
                        }
                    )
                }
            }

            CircleIcon(
                modifier = Modifier.margin(left = Dimen.smallPadding),
                img = Res.PathIcon.delete,
                borderColor = Theme.Transparent.rgb,
                size = Dimen.mediumIconSize,
                onIconClick = {
                    onDelete()
                }
            )
        }
    //} else {
        //
    //}
}
